import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-ug-programs',
  templateUrl: './ug-programs.component.html',
  styleUrls: ['./ug-programs.component.scss']
})
export class UgProgramsComponent implements OnInit {

 constructor(private crudService: CrudService) { }

  baseUrl = this.crudService.baseUrl;
  baseUrl1 = this.crudService.baseUrl1;
  

  ngOnInit(): void {
  }

}
